import React from 'react';
import { useSelector } from 'react-redux';
import Modal, {
  CONTENT_POSITION,
  OPACITY_LAYOUT_COLORS,
  IN_SCENE_EFFECT,
  OUT_SCENE_EFFECT,
} from '@bit/gerenciatd.unifiedcomponents.modal';
import { LIGHT_BOX_CONTENT } from '@bit/gerenciatd.utils.tagging';
import ProductModal from '../components/ProductModal';
import { TYPE_PRODUCT } from '../components/ProductItem';

/**
 * Hook para manejar la interaccion con el FlyOut de producto
 */
export const useProductModal = ({ variant }) => {
  const { data: context } = useSelector((state) => state.context);

  /**
   * funcion para mostrar el modal de producto (flyOut)
   * @param {obj} info informacion de la modal
   * @param {string} titleHeader titulo de la modal
   * @param {bool} shouldShowSections flag para mostrar las secciones
   * @param {bool} shouldShowCta flag para mostrar la sticky bar con el precio
   * @returns {jsx}
   */
  const showProductModal = (
    info,
    titleHeader,
    shouldShowSections = true,
    shouldShowCta,
    isLanding = false
  ) => {
    if (!context) {
      console.error('No existe el context');
      return;
    }

    let componentProduct = '';
    if (
      info
      && info.selectedProduct.product.name
      && info.selectedProduct.product.taxonomy
    ) {
      componentProduct = `${info.selectedProduct.product.name};${info.selectedProduct.product.taxonomy}`;
    }

    let componentVariation = 'all';
    if (context && context.userType !== '') {
      componentVariation = 'config';
    }

    const taggingInfo = {
      componentName:
        info.typeProduct === TYPE_PRODUCT.RECOMMENDED
          ? 'ProductModalRecommended'
          : 'ProductModal',
      componentVariation,
      componentProduct,
    };
    Modal.setModalProps({
      contentPosition:
        context.device === 'mobile'
          ? CONTENT_POSITION.CENTER_TOP
          : CONTENT_POSITION.RIGHT_TOP,
      opacityLayoutColor:
        context.device === 'mobile'
          ? OPACITY_LAYOUT_COLORS.WHITE
          : OPACITY_LAYOUT_COLORS.BLACK05,
      inSceneEffect:
        context.device === 'mobile'
          ? IN_SCENE_EFFECT.FADE_IN
          : IN_SCENE_EFFECT.FADE_IN_RIGHT,
      outSceneEffect:
        context.device === 'mobile'
          ? OUT_SCENE_EFFECT.FADE_OUT
          : OUT_SCENE_EFFECT.FADE_OUT_RIGHT,
      closeByClickingOutside: context.device !== 'mobile',
      contentInsideContainer: context.device === 'mobile' ? false : false,
      scrollAllowed: context.device === 'mobile' ? false : false,
      show: true,
      className: 'ProductModalContainer',
      taggingInfoWhenClickingOutside: {
        ...taggingInfo,
        componentContent: LIGHT_BOX_CONTENT.CLICK_OUTSIDE,
      },
    });
    const urlProdCompraForFlyout = info
      && info.downGradeButtonLink
      && info.downGradeButtonLink.includes('&prevPosCode')
      ? info.downGradeButtonLink.split('&prevPosCode')[0]
      : info.downGradeButtonLink;
    Modal.setContent(
      <ProductModal
        info={info}
        titleHeader={titleHeader}
        showSections={shouldShowSections}
        taggingInfo={taggingInfo}
        downGradeButtonLink={urlProdCompraForFlyout}
        downgradeOnClick={info.downgradeOnClick}
        showCta={shouldShowCta}
        isLanding={isLanding}
        variant={variant}
      />
    );
    Modal.show();
  };

  /**
   * Funcion para cambiar de seccion (tab) en el flyOut
   * @param {obj} info informacion de la modal
   * @param {string} titleHeader titulo de la modal
   * @param {bool} shouldShowSections flag para mostrar las secciones
   * @param {bool} shouldShowCta flag para mostrar el cta
   * @returns {jsx}
   */
  const changeSection = (
    info,
    titleHeader,
    shouldShowSections = true,
    shouldShowCta = true
  ) => {
    let componentProduct = '';
    if (
      info
      && info.selectedProduct.product.name
      && info.selectedProduct.product.taxonomy
    ) {
      componentProduct = `${info.selectedProduct.product.name};${info.selectedProduct.product.taxonomy}`;
    }
    const taggingInfo = {
      componentVariation: 'all',
      componentName:
        info.typeProduct === TYPE_PRODUCT.RECOMMENDED
          ? 'ProductModalRecommended'
          : 'ProductModal',
      componentProduct,
    };
    Modal.setContent(
      <ProductModal
        info={info}
        showSections={shouldShowSections}
        titleHeader={titleHeader}
        taggingInfo={taggingInfo}
        downGradeButtonLink={info.downGradeButtonLink}
        downgradeOnClick={info.downgradeOnClick}
        showCta={shouldShowCta}
      />
    );
  };

  return {
    showProductModal: (
      info,
      titleHeader,
      shouldShowSections,
      shouldShowCta,
      isLanding
    ) => showProductModal(
      info,
      titleHeader,
      shouldShowSections,
      shouldShowCta,
      isLanding
    ),
    changeSection: (info, titleHeader, shouldShowSections, shouldShowCta) => changeSection(info, titleHeader, shouldShowSections, shouldShowCta),
  };
};
